import React from "react";

function CloseIcon() {
  return (
    <svg
      stroke="currentColor"
      fill="#a395b1"
      stroke-width="0"
      viewBox="0 0 512 512"
      height="30px"
      width="30px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
    </svg>
  );
}

export default CloseIcon;
